import type { Config } from '../config/types';

export abstract class BaseNetworkHandler {
  readonly config: Config;

  constructor(options: Config) {
    this.config = options;
  }

  abstract sendRequest(payload: Uint8Array): Promise<void>;
}
